import { Center, Text } from '@chakra-ui/react'
import { lang } from '@src/lang'

export const NoData = () => {
    return (
        <Center height="100%" width="full" minW="0" px="2">
            <Text color="gray.focusRing" fontSize="clamp(16px, 1.6vw, 24px)" textAlign="center" whiteSpace="nowrap">
                {lang.noValue}
            </Text>
        </Center>
    )
}
